import axios from 'axios';
import store from '../store';
import addError from './AddError';

export const RECENT_MQL_PLUS_LEADS_REQUESTED = 'RECENT_MQL_PLUS_LEADS_REQUESTED';
export const RECENT_MQL_PLUS_LEADS_COMPLETED = 'RECENT_MQL_PLUS_LEADS_COMPLETED';
export const RECENT_MQL_PLUS_LEADS_FAILED = 'RECENT_MQL_PLUS_LEADS_FAILED';

const getRecentMqlPlusLeads = days => (
  (dispatch) => {
    dispatch({
      type: RECENT_MQL_PLUS_LEADS_REQUESTED,
    });

    return axios
      .get('/api/leads/bulk-leads', {
        params: { days },
      })
      .then((response) => {
        dispatch({
          type: RECENT_MQL_PLUS_LEADS_COMPLETED,
          data: {
            recent_dq_leads: response.data,
          },
        });
      }).catch((error) => {
        dispatch({
          type: RECENT_MQL_PLUS_LEADS_FAILED,
        });

        return store.dispatch(addError({
          text: 'Unable to get recent Mql Plus leads',
          originalError: error,
        }));
      });
  }
);

export default getRecentMqlPlusLeads;
